import http from '../../../utils/fetch';
export default {
    selectPage(query) {
        return http({
            url: '/api/swyl/v1/demo/bscPartnerHighSeas/selectPage',
            method: 'post',
            params: query
        });
    },
    selectById(query) {
        return http({
            url: '/api/swyl/v1/demo/bscPartnerHighSeas/selectById?id='+query,
            method: 'post',
        });
    },
    deleteList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscPartnerHighSeas/deleteList',
            method: 'post',
            data: query
        });
    },
    updateById(query) {
        return http({
            url: '/api/swyl/v1/demo/bscPartnerHighSeas/updateById',
            method: 'post',
            params: query
        });
    },
    selectPressLog(mainId) {
        return http({
            url: '/api/swyl/v1/demo/bscPartnerHighSeas/selectPressLog?mainId='+mainId,
            method: 'post',
        });
    },

    //催办
    press(query) {
        return http({
            url: '/api/swyl/v1/demo/bscPartnerHighSeas/press',
            method: 'post',
            params: query
        });
    },


}
